export default __webpack_public_path__ + "static/media/whatAreCostcodes.b2948f1c.png";